/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AwsAccountMetricsDestination {
  /**
  * CloudWatch region to publish metrics to.
  */
  'region'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsAccountMetricsDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

